import {
	AfterViewInit,
	CUSTOM_ELEMENTS_SCHEMA,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	Inject,
	Input,
	OnDestroy,
	OnInit,
	PLATFORM_ID,
	ViewChild,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import {
	additionalTiles,
	courseInfoTiles,
	clearingTiles,
	regularDescription,
	clearingDescription,
} from './popular-subjects.properties';
import { PopularSubjectsApiService } from './data-access/popular-subjects-api.service';

import { Environment } from '@uc/utilities';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { DescriptionComponent } from '@uc/shared/ui';
import { SearchSvgComponent } from '@uc/shared/svg';

export interface Tiles {
	title: string;
	img?: string;
	courseAmt: number;
	searchTerm: string;
}
@Component({
	selector: 'uc-popular-subjects',
	templateUrl: './popular-subjects.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, RouterModule, SearchSvgComponent, DescriptionComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PopularSubjectsComponent implements OnInit, AfterViewInit, OnDestroy {
	@Input() showButton = true;
	@Input() sectionTitle: string | null = null;
	@Input() sectionDesc: string | null = null;

	@ViewChild('swiperRef') protected swiperRef: ElementRef | undefined;

	/**
	 * @courseNumSub - I used a subscription to get data instead of observable$ | async:
	 * Reason: to decrease display times
	 * With this approach, the dummy numbers are immediately displayed before we receive a response from the DB
		As it is located quite high on the home page, I felt it is the safer way for users with low internet connections.
	 */
	courseNumSub!: Subscription;
	tiles: Tiles[][] = courseInfoTiles;
	private path = '';
	private optionalTiles = additionalTiles;
	private clearingTiles = clearingTiles;

	clearingEnabled!: boolean;

	description = regularDescription;

	constructor(
		@Inject(PLATFORM_ID) private _platformId: object,
		@Inject('environment') environment: Environment,
		private _cd: ChangeDetectorRef,
		private _router: Router,
		private _popularSubjectsApiSrv: PopularSubjectsApiService,
	) {
		this.clearingEnabled = environment.clearingEnabled;
	}

	ngOnInit(): void {
		this.path = this._router.url;

		if (this.clearingEnabled) {
			this.description = clearingDescription;
			this.tiles = [...this.clearingTiles];
		} else if (this.path.includes('courses')) {
			this.tiles = [...this.tiles, ...this.optionalTiles];
		}

		this.courseNumSub = this._popularSubjectsApiSrv
			.getPopularSubjects()
			.subscribe((data) => {
				if (!data) return;

				this.tiles.forEach((section) => {
					section.forEach((section) => {
						let nameKey = section.title;

						if (section.title === 'Comp Sci') {
							nameKey = 'Computer';
						} else if (section.title === 'Sports Sci') {
							nameKey = 'Sports';
						}

						const subject = data.find((subject) => subject.name === nameKey);
						if (subject?.courses_count) {
							section.courseAmt = subject?.courses_count;
						}
					});
				});

				this._cd.detectChanges();
			});
	}

	ngAfterViewInit(): void {
		if (isPlatformBrowser(this._platformId)) {
			this._initSwiper();
		}
	}

	ngOnDestroy(): void {
		if (this.courseNumSub) this.courseNumSub.unsubscribe();
	}

	private _initSwiper() {
		const config = {
			slidesPerView: 1.4,
			spaceBetween: 10,
			loop: false,
			noSwipingClass: 'swiper-no-swiping',
			breakpoints: {
				768: {
					slidesPerView: 4,
					spaceBetween: 20,
					slidesPerGroup: 4,
				},
			},
		};

		const swiperEl = this.swiperRef?.nativeElement;
		Object.assign(swiperEl, config);

		swiperEl?.initialize();
	}
}
